import { useCart } from "@/context/CartContext";
import { useNavigate, Link } from "react-router-dom";
import { X } from "lucide-react";
import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function CartDrawer() {
    const { items, open, setOpen, remove, subtotal } = useCart();
    const navigate = useNavigate();
    const [tease, setTease] = useState(null);

    useEffect(() => {
        if (!open) return;
        api.get(`/shipping/uk-tease?subtotal=${subtotal}`).then(({ data }) => setTease(data)).catch(() => setTease(null));
    }, [open, subtotal]);

    const gbp = (n) => `£${Number(n).toLocaleString("en-GB", { minimumFractionDigits: 0 })}`;

    return (
        <>
            <div
                className={`drawer-backdrop ${open ? "open" : ""}`}
                onClick={() => setOpen(false)}
                aria-hidden="true"
            />
            <aside className={`drawer ${open ? "open" : ""}`} aria-label="Shopping bag" data-testid="cart-drawer">
                <div className="drawer-head">
                    <div className="eyebrow">Your Bag ({items.length})</div>
                    <button className="drawer-close" onClick={() => setOpen(false)} aria-label="Close bag" data-testid="cart-drawer-close">
                        <X size={20} strokeWidth={1.4} />
                    </button>
                </div>

                <div className="drawer-body">
                    {items.length === 0 ? (
                        <div className="drawer-empty" data-testid="cart-empty">
                            Your bag is empty.
                            <div style={{ marginTop: 16 }}>
                                <Link to="/shop" className="link-underline" onClick={() => setOpen(false)}>
                                    Continue browsing
                                </Link>
                            </div>
                        </div>
                    ) : (
                        items.map((it) => (
                            <div key={it.id} className="drawer-item" data-testid={`cart-item-${it.id}`}>
                                {it.image && <img src={it.image} alt={it.title} />}
                                <div className="info">
                                    <div className="d">{it.designer}</div>
                                    <div>{it.title}</div>
                                    <div style={{ color: "var(--cocoa-soft)", marginTop: 4 }}>
                                        Size {it.size} · {gbp(it.price)}
                                    </div>
                                    <button
                                        className="remove"
                                        onClick={() => remove(it.id)}
                                        data-testid={`cart-item-remove-${it.id}`}
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {items.length > 0 && (
                    <div className="drawer-foot">
                        {tease?.applicable && (
                            <div style={{ marginBottom: 12, padding: "10px 12px", background: "var(--parchment-soft)", border: "1px solid var(--sand-line)", fontFamily: "var(--font-serif)", fontSize: 14, textAlign: "center", color: "var(--cocoa)" }} data-testid="cart-tease">
                                {tease.unlocked
                                    ? <>You&rsquo;ve unlocked <strong>free UK shipping</strong>.</>
                                    : <>Add <strong>{gbp(tease.remaining)}</strong> for free UK shipping.</>}
                            </div>
                        )}
                        <div className="subtotal">
                            <span>Subtotal</span>
                            <span className="amt">{gbp(subtotal)}</span>
                        </div>
                        <div className="note">Shipping calculated at checkout</div>
                        <button
                            className="btn"
                            onClick={() => {
                                setOpen(false);
                                navigate("/checkout");
                            }}
                            data-testid="cart-checkout-btn"
                        >
                            Checkout
                        </button>
                    </div>
                )}
            </aside>
        </>
    );
}
